import { render, staticRenderFns } from "./EzRadioButton.vue?vue&type=template&id=4ef6fbea&scoped=true&"
import script from "./EzRadioButton.vue?vue&type=script&lang=js&"
export * from "./EzRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./EzRadioButton.vue?vue&type=style&index=0&id=4ef6fbea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6fbea",
  null
  
)

export default component.exports